import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import React from "react";
import svgLogo from "../images/logo-full.svg"
import Image from 'react-bootstrap/Image';
import "bootstrap/dist/css/bootstrap.min.css"
import styles from "./navbar.module.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowLeft } from "react-icons/fa";
import GalleriesModal from "./galleries-modal";

import { Link, animateScroll as scroll } from "react-scroll";

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false
        };
    }

    goToTop = () => {
        scroll.scrollToTop();
    }

    renderStandard() {
        return <>
            {/* <Navbar.Brand href="/">
                <Image
                    src={svgLogo}
                    style={{
                        height: 30,
                        marginBottom: 0
                    }} />
            </Navbar.Brand> */}
            <Navbar.Collapse>
                <Nav>
                    <Nav.Link href="/"><FaArrowLeft /> Volver</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </>
    }

    renderMain() {
        return <Container
            fluid
            style={{
                maxWidth: 700,
                textAlign: "center"
            }}>
            <GalleriesModal
                showAll={this.state.showAll}
                onHide={() => this.setState({ showAll: false })} />
            <Row style={{ textAlign: "center", width: "100%" }}>
                <Col>
                    <Link
                        style={{
                            fontWeight: "bold",
                            textShadow: "3px 3px 8px black"
                        }}
                        onClick={this.goToTop}>
                        <a href="#">Inicio</a>
                    </Link>
                </Col>
                <Col>
                    <Link
                        style={{
                            fontWeight: "bold",
                            textShadow: "3px 3px 8px black"
                        }}
                        onClick={() => this.setState({ showAll: true })}>
                        <a href="#">Galerías</a>
                    </Link>
                </Col>
                <Col>
                    <Link
                        style={{
                            fontWeight: "bold",
                            textShadow: "3px 3px 8px black"
                        }}
                        to="cv"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}>
                        <a href="#">CV</a>
                    </Link>
                </Col>
                <Col>
                    <Link
                        style={{
                            fontWeight: "bold",
                            textShadow: "3px 3px 8px black"
                        }}
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}>
                        <a href="#">Contacto</a>
                    </Link>
                </Col>
            </Row>
        </Container>;
    }

    render() {
        return <Navbar
            variant="dark"
            bg="dark"
            expand
            sticky="top"
            style={{
                boxShadow: "0px 10px 8px #0c0c0c",
                WebkitBoxShadow: "0px 10px 8px #0c0c0c",
            }}>
            {this.props.main ? this.renderMain() : this.renderStandard()}
        </Navbar>;
    }
}